import Axios from "../api/axios";
import config from "../../config";

const saveDraftLawyer = (token, updateData) => {

const payload = Object.entries(updateData).reduce((acc, [key, value]) => {
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});
  return Axios.post(`${config.BASE_URL}save-draft-lawyer`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export default saveDraftLawyer;
